export default "__VITE_ASSET__PWX$tbDq__"